import { render } from "./market_details.vue?vue&type=template&id=23f0d05e"
import script from "./market_details.vue?vue&type=script&lang=js"
export * from "./market_details.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__